import api from './api';
import { PaginatedResponse, Dress } from '../types';

export interface StaffPick {
  id: string;
  displayOrder: number;
  note?: string;
  dress: Dress;
}

export interface StaffPickCountResponse {
  count: number;
}

class StaffPicksService {
  async getStaffPicks(page: number = 1, limit: number = 20): Promise<PaginatedResponse<StaffPick>> {
    const response = await api.get<PaginatedResponse<StaffPick>>('/staff-picks', {
      page,
      limit
    });
    return response.data;
  }

  async getStaffPicksCount(): Promise<number> {
    const response = await api.get<{ data: StaffPickCountResponse }>('/staff-picks/count');
    return response.data.data.count;
  }
}

export default new StaffPicksService();
